<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/insRecord'}">巡检记录</el-breadcrumb-item>
                <el-breadcrumb-item>添加</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" style="width:60%;margin:0 auto">
                <el-form-item label="路线" prop="inspectionRouteId">
                    <el-select size="small" v-model="ruleForm.inspectionRouteId" filterable allow-create @change="selectChange">
                        <el-option
                                v-for="item in routes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="计划编号" prop="jobs">
                    <el-input size="small" :disabled="true" v-model="ruleForm.number" style="width:500px"></el-input>
                </el-form-item> -->
                <el-form-item label="名称" prop="name">
                    <el-input  size="small" v-model="ruleForm.name" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="巡检人" prop="inspectionMan">
                    <el-select size="small" v-model="userIds" multiple placeholder="请添加巡检人" style="width:500px">
                        <el-option
                                v-for="item in userData"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划开始时间" prop="planStartTime">
                    <el-date-picker size="small"
                                    v-model="ruleForm.planStartTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="计划完成时间" prop="planEndTime">
                    <el-date-picker size="small"
                                    v-model="ruleForm.planEndTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            <el-button size="small" type="primary" class="addBtn" @click="submitForm('ruleForm')">确定</el-button>
        </div>

    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        data() {
          var checkUser = (rule, value, callback) => {
            if(this.userIds.length === 0) {
              return callback(new Error('请选择巡检人'))
            }else{
              callback()
            }
          };
            return {
                userData:[],
                currentRoute:{},
                routes:[],
                ruleForm: {
                    name: "",
                },
                rules: {
                    inspectionRouteId: [{required: true, message: "请选择路线", trigger: "blur"}],
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                    inspectionMan: [{required: true, validator: checkUser}],
                    planStartTime: [{required: true, message: "请选择计划开始时间", trigger: "blur"}],
                    planEndTime: [{required: true, message: "请选择计划结束时间", trigger: "blur"}],
                },
                options: [
                    {
                        value: "班长",
                        label: "班长",
                    },
                    {
                        value: "副班长",
                        label: "副班长",
                    },
                    {
                        value: "经理",
                        label: "经理",
                    },
                ],
                getObj: {},
                userIds:[],
            };
        },
        mounted:function(){
            this.getRoutes();
            this.getAllUser();
        },
        methods: {
            //获取所有用户信息
            getAllUser() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.userData = res.body.data;
                    });
            },
            getRoutes(){
                this.componentsMoudel.httpRequest
                    .getRequestHander("/inspectionroute/getAll")
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.routes = res.body.data;
                        this.currentPage = res.body.page;
                        this.total = res.body.cum;
                        this.pageTotal = res.body.pageTotal;
                    });
            },
            getRoutesDetailInfo(val){
                this.componentsMoudel.httpRequest
                    .getRequestHander("/inspectionroute/info/"+val)
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.currentRoute = res.body.data;
                        this.ruleForm.number = this.currentRoute.serialNumber;
                        this.ruleForm.name = this.currentRoute.name;
                        this.userIds = [];
                        for (var i = 0; i < this.currentRoute.userVos.length; i++) {
                            var userVo = this.currentRoute.userVos[i].id;
                            this.userIds.push(userVo);
                        }
                    });
            },
            selectChange(val){
                this.getRoutesDetailInfo(val);

            },
            submitForm() {
              this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                  this.ruleForm.inspectionMan = JSON.stringify(this.userIds);
                  this.componentsMoudel.httpRequest
                  .getRequestHander("/inspectionrecord/save")
                  .openLoad()
                  .startPost(this.ruleForm)
                  .then((res) => {
                      if (res.result == "success") {
                          this.$message({
                              showClose: true,
                              message: "添加成功",
                              type: "success",
                          });
                          this.$router.push({
                              path: "/processManager/insRecord",
                          });
                      }
                  });
                } else {
                  return false;
                }
              });
            },
        },
        created() {
        },
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
